// extracted by mini-css-extract-plugin
module.exports = {"wuiocxb":"wuiocxb"};